import mout from 'mout';

export default {
  install: function(Vue,) {
    Object.defineProperty(Vue.prototype, '$mout', { value: mout });
  }
}